import styled from 'styled-components';
import star from '../images/star.svg'
import "../style/term-modal.css";
import { useState } from 'react';
import { Modal } from 'antd'

const IconWrap = styled.a`
    display: inline-block;
    & svg {
        fill: rgba(255, 255, 255, 0.7); 
        &:hover {
            fill: rgba(233, 186, 85); 
        }
    }
    & + & {
      margin-left: 32px;
    }
`

const TermLink = styled.div`
  margin-top: 24px;
  padding: 0 12px;
  color: rgba(167, 151, 109);
  font-size: 16px;
  &:hover {
    cursor: pointer;
    color: rgba(233, 186, 85);
  }
`

const Footer = styled.footer`
  padding: 80px 0 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`

const Line = styled.div`
  width: 100%;
  height: 1px;
  background-color: rgba(167, 151, 109);
`

const FlexWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

const TermTitle = styled.div`
  font-size: 48px;
  letter-spacing: 0.5px;
  line-height: 58px;
  color: transparent;
  text-align: center;
  background-clip: text;
  -webkit-background-clip: text;
  background-image: linear-gradient(90deg,#a6762e 0%,#e3d2a6 52.6%,#a6762e 100%);
`

const ContentWrap = styled.div`
  color: rgba(178, 178, 178);
  font-size: 16px;
  letter-spacing: 0.8px;
  line-height: 28px;
  margin-top: 24px
`

const ConetentList = styled.li`
  margin-left: 16px;

  & + & {
    margin-top: 8px;
  }
`

const AppFooter = () => {
  const [isTermModalVisible, setTermModalVisible] = useState(false)
  return (
    <Footer>
      <div style={{ display: 'flex', justifyContent: 'center', padding: '0 12px' }}>
        <IconWrap href='https://twitter.com/therenartclub' target='_blank'>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20 2.79923C19.2642 3.18028 18.4733 3.43691 17.6433 3.55259C18.4908 2.96059 19.1417 2.02253 19.4475 0.904638C18.655 1.45289 17.7767 1.85145 16.8417 2.06628C16.0942 1.13599 15.0267 0.554688 13.8467 0.554688C11.1975 0.554688 9.25083 3.43789 9.84917 6.43093C6.44 6.23165 3.41667 4.32637 1.3925 1.43053C0.3175 3.58176 0.835 6.39594 2.66167 7.82101C1.99 7.79574 1.35667 7.58091 0.804167 7.22221C0.759167 9.43953 2.12167 11.514 4.095 11.9757C3.5175 12.1584 2.885 12.2012 2.24167 12.0574C2.76333 13.9587 4.27833 15.342 6.075 15.3809C4.35 16.9586 2.17667 17.6634 0 17.364C1.81583 18.722 3.97333 19.5142 6.29 19.5142C13.9083 19.5142 18.2125 12.0087 17.9525 5.27707C18.7542 4.60147 19.45 3.75867 20 2.79923Z"></path>
          </svg>
        </IconWrap>
        <IconWrap href='https://www.instagram.com/renart.nft/' target='_blank'>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.55556 0C2.49222 0 0 2.49222 0 5.55556V14.4444C0 17.5078 2.49222 20 5.55556 20H14.4444C17.5078 20 20 17.5078 20 14.4444V5.55556C20 2.49222 17.5078 0 14.4444 0H5.55556ZM5.55556 2.22222H14.4444C16.2822 2.22222 17.7778 3.71778 17.7778 5.55556V14.4444C17.7778 16.2822 16.2822 17.7778 14.4444 17.7778H5.55556C3.71778 17.7778 2.22222 16.2822 2.22222 14.4444V5.55556C2.22222 3.71778 3.71778 2.22222 5.55556 2.22222ZM15.5556 3.33333C15.2609 3.33333 14.9783 3.4504 14.7699 3.65877C14.5615 3.86714 14.4444 4.14976 14.4444 4.44444C14.4444 4.73913 14.5615 5.02174 14.7699 5.23012C14.9783 5.43849 15.2609 5.55556 15.5556 5.55556C15.8502 5.55556 16.1329 5.43849 16.3412 5.23012C16.5496 5.02174 16.6667 4.73913 16.6667 4.44444C16.6667 4.14976 16.5496 3.86714 16.3412 3.65877C16.1329 3.4504 15.8502 3.33333 15.5556 3.33333ZM10 4.44444C6.93667 4.44444 4.44444 6.93667 4.44444 10C4.44444 13.0633 6.93667 15.5556 10 15.5556C13.0633 15.5556 15.5556 13.0633 15.5556 10C15.5556 6.93667 13.0633 4.44444 10 4.44444ZM10 6.66667C11.8378 6.66667 13.3333 8.16222 13.3333 10C13.3333 11.8378 11.8378 13.3333 10 13.3333C8.16222 13.3333 6.66667 11.8378 6.66667 10C6.66667 8.16222 8.16222 6.66667 10 6.66667Z"></path>
          </svg>
        </IconWrap>
        <IconWrap href='https://discord.gg/pFEuQPcQHM' target='_blank'>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16.9308 2.33024C15.6561 1.63724 14.2892 1.12666 12.8599 0.834235C12.8339 0.828591 12.8079 0.842695 12.7945 0.870904C12.6187 1.24137 12.4239 1.72468 12.2876 2.10456C10.7503 1.83188 9.22099 1.83188 7.71527 2.10456C7.57887 1.71624 7.37707 1.24137 7.20048 0.870904C7.18707 0.843636 7.16107 0.829532 7.13504 0.834235C5.70659 1.12573 4.33963 1.6363 3.06411 2.33024C3.05307 2.33588 3.04361 2.3453 3.03732 2.35751C0.444493 6.94709 -0.265792 11.4239 0.0826501 15.8451C0.0842267 15.8667 0.0944749 15.8874 0.108665 15.9006C1.81934 17.3891 3.47642 18.2927 5.10273 18.8916C5.12876 18.9011 5.15634 18.8898 5.1729 18.8644C5.55761 18.2419 5.90054 17.5856 6.19456 16.8954C6.21192 16.855 6.19535 16.807 6.15989 16.791C5.61594 16.5466 5.098 16.2485 4.59977 15.91C4.56037 15.8827 4.55721 15.8159 4.59347 15.784C4.69831 15.6909 4.80318 15.594 4.9033 15.4962C4.92141 15.4784 4.94665 15.4746 4.96794 15.4859C8.24107 17.2565 11.7846 17.2565 15.0191 15.4859C15.0404 15.4737 15.0657 15.4775 15.0846 15.4953C15.1847 15.5931 15.2895 15.6909 15.3952 15.784C15.4314 15.8159 15.4291 15.8827 15.3897 15.91C14.8914 16.2551 14.3735 16.5466 13.8288 16.7901C13.7933 16.8061 13.7775 16.855 13.7949 16.8954C14.0952 17.5846 14.4381 18.241 14.8157 18.8634C14.8315 18.8898 14.8599 18.9011 14.8859 18.8916C16.5201 18.2927 18.1772 17.3891 19.8879 15.9006C19.9028 15.8874 19.9123 15.8677 19.9139 15.846C20.3309 10.7346 19.2154 6.29453 16.9568 2.35845C16.9513 2.3453 16.9419 2.33588 16.9308 2.33024ZM6.68335 13.153C5.69792 13.153 4.88594 12.0811 4.88594 10.7647C4.88594 9.44827 5.68217 8.37635 6.68335 8.37635C7.69239 8.37635 8.49651 9.45768 8.48073 10.7647C8.48073 12.0811 7.68451 13.153 6.68335 13.153ZM13.329 13.153C12.3435 13.153 11.5316 12.0811 11.5316 10.7647C11.5316 9.44827 12.3278 8.37635 13.329 8.37635C14.338 8.37635 15.1421 9.45768 15.1264 10.7647C15.1264 12.0811 14.338 13.153 13.329 13.153Z"></path>
          </svg>
        </IconWrap>
        <IconWrap href='https://opensea.io/collection/trac' target='_blank'>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M20 10C20 15.5225 15.5225 20 10 20C4.47746 20 0 15.5225 0 10C0 4.47746 4.47746 0 10 0C15.5237 0 20 4.47746 20 10ZM4.93358 10.336L4.97672 10.2682L7.57812 6.19864C7.61614 6.13906 7.70552 6.14522 7.73428 6.20994C8.16888 7.18392 8.54388 8.39524 8.3682 9.14936C8.2932 9.45964 8.08772 9.87984 7.85654 10.2682C7.82676 10.3247 7.79388 10.3802 7.75894 10.4336C7.7425 10.4583 7.71476 10.4727 7.68496 10.4727H5.0096C4.93768 10.4727 4.89556 10.3946 4.93358 10.336ZM16.5289 11.7364V11.0922C16.5289 11.0326 16.4714 10.9895 16.4148 11.0059L13.3727 11.8854C13.3563 11.8895 13.3419 11.8987 13.3306 11.911C13.0048 12.2709 12.7278 12.5125 12.6545 12.5765L12.6494 12.5809C12.4604 12.7412 12.2261 12.8285 11.9795 12.8285H10.8781V11.7056H11.7535C11.7761 11.7056 11.7977 11.6973 11.8141 11.683L11.9271 11.5792C11.9754 11.535 12.033 11.4816 12.1018 11.4127C12.1076 11.4069 12.1136 11.401 12.1196 11.395C12.1557 11.359 12.1944 11.3204 12.2323 11.2782C12.2775 11.234 12.3217 11.1847 12.3627 11.1364C12.4316 11.0624 12.4973 10.9853 12.5662 10.9042C12.6155 10.8508 12.6607 10.7901 12.7049 10.7295C12.7542 10.672 12.8025 10.6073 12.8477 10.5456C12.8645 10.5209 12.8824 10.4959 12.9007 10.4704C12.9182 10.446 12.936 10.4212 12.9535 10.3956C12.9864 10.3463 13.0193 10.2939 13.047 10.2446C13.1333 10.111 13.2063 9.9682 13.2679 9.8254C13.2962 9.76423 13.3188 9.69983 13.3408 9.63723C13.3436 9.62937 13.3463 9.62155 13.3491 9.61376C13.3737 9.5408 13.3943 9.47198 13.4097 9.39902C13.4467 9.22744 13.4549 9.0569 13.4384 8.88634C13.4343 8.83292 13.4302 8.78052 13.4179 8.73122V8.723C13.4138 8.68806 13.4056 8.64902 13.3943 8.61306C13.3573 8.44662 13.2997 8.28018 13.2268 8.11682C13.2021 8.0562 13.1734 7.99456 13.1456 7.93806C13.0799 7.8158 13.011 7.69352 12.933 7.57538C12.9173 7.55043 12.9 7.52514 12.8827 7.49991C12.8694 7.48046 12.8561 7.46105 12.8436 7.44182C12.7941 7.36555 12.7385 7.29202 12.6846 7.22067C12.6724 7.20455 12.6603 7.18854 12.6484 7.17264C12.6165 7.13082 12.5817 7.08901 12.5466 7.04693C12.5273 7.02386 12.508 7.0007 12.4891 6.97742C12.4357 6.9127 12.3833 6.85106 12.3299 6.79044C12.1388 6.57468 11.9384 6.37948 11.7597 6.21304C11.7268 6.18016 11.6908 6.14728 11.6538 6.11544C11.5151 5.98906 11.3888 5.87912 11.2829 5.79386C11.2512 5.7694 11.2226 5.74531 11.1961 5.72288C11.178 5.70761 11.1609 5.69313 11.1442 5.67982C11.1122 5.65592 11.0843 5.63472 11.061 5.61692C11.0462 5.60563 11.0331 5.59571 11.022 5.58734C11.0138 5.58118 11.0045 5.57708 10.9953 5.57398L10.8781 5.54112V4.57124C10.8781 4.41302 10.8144 4.27124 10.7127 4.16746C10.611 4.0637 10.4692 4 10.3131 4C10.0007 4 9.748 4.25582 9.748 4.57124V5.22466L9.68944 5.20824L9.53018 5.16302L9.38532 5.12296C9.3849 5.12296 9.38447 5.12278 9.38397 5.12257C9.38327 5.12228 9.38242 5.12192 9.38122 5.12192H9.37814L8.2788 4.82398C8.23052 4.81062 8.18942 4.86302 8.21408 4.9072L8.38976 5.23186C8.39974 5.25681 8.41238 5.28176 8.42536 5.30741C8.43376 5.324 8.44231 5.34088 8.45038 5.35824C8.47916 5.41576 8.50792 5.47638 8.53566 5.537C8.56032 5.59042 8.58498 5.64282 8.61374 5.70036C8.62583 5.72741 8.63816 5.75478 8.65066 5.78254C8.69658 5.88451 8.74487 5.99174 8.7925 6.10722C8.8336 6.20482 8.8747 6.30242 8.91066 6.40414C9.0093 6.65996 9.10278 6.93324 9.18396 7.21374C9.20416 7.27651 9.2203 7.33726 9.23667 7.39883C9.2436 7.42492 9.25058 7.45117 9.25792 7.47778L9.26922 7.52708C9.3021 7.65758 9.33088 7.78702 9.35142 7.9175C9.36786 8.00688 9.38326 8.09216 9.39148 8.17846C9.40382 8.27606 9.41614 8.37368 9.42026 8.47128C9.42848 8.56066 9.43258 8.65416 9.43258 8.74354C9.43258 8.97162 9.41204 9.19148 9.36374 9.39902C9.36071 9.41018 9.35769 9.42148 9.35463 9.43288C9.34111 9.48337 9.3271 9.53572 9.31032 9.58602C9.29515 9.63989 9.27548 9.69376 9.25506 9.74971C9.24784 9.76951 9.24051 9.78957 9.23326 9.80998C9.23191 9.81362 9.23055 9.81726 9.2292 9.82091C9.21409 9.8616 9.19871 9.90302 9.17984 9.94356C9.07812 10.1881 8.95176 10.4316 8.82128 10.6597C8.63018 10.9977 8.43806 11.2946 8.30346 11.4857C8.29523 11.4981 8.28719 11.5098 8.27945 11.5211C8.26982 11.5352 8.26064 11.5486 8.2521 11.5617C8.20998 11.6213 8.25312 11.7056 8.32606 11.7056H9.748V12.8285H8.30962C7.92332 12.8285 7.56578 12.6097 7.39318 12.2593C7.3038 12.0836 7.26886 11.8905 7.28942 11.7014C7.29454 11.6449 7.25242 11.5915 7.1949 11.5915H4.28938C4.24006 11.5915 4.2 11.6316 4.2 11.6809V11.7405C4.2 13.5939 5.69694 15.096 7.5442 15.096H12.7562C13.7332 15.096 14.288 14.2057 14.8333 13.3306C14.9853 13.0867 15.1365 12.844 15.296 12.622C15.5826 12.2234 16.272 11.9069 16.4734 11.8206C16.5063 11.8062 16.5289 11.7734 16.5289 11.7364Z"></path>
          </svg>
        </IconWrap>
      </div>
      <TermLink onClick={() => setTermModalVisible(true)}>
        Terms & conditions
      </TermLink>
      <FlexWrap style={{ width: '100%', marginTop: '24px' }}>
        <Line />
        <FlexWrap style={{ flexShrink: 0, margin: '0 44px' }}>
          <img src={star} alt="star" />
        </FlexWrap>
        <Line />
      </FlexWrap>
      <div style={{ padding: '0 12px', marginTop: '24px', color: 'rgba(167, 151, 109)', fontSize: '12px', textAlign: 'center' }}>
        <div style={{ lineHeight: 2 }}>Copyright 2022 / The Renaissance Club</div>
        <div style={{ lineHeight: 2 }}>
          Da Vinci Code Cryptex by TAIGA-ZOE is licensed under Creative Commons Attribution
        </div>
      </div>
      <Modal
        visible={isTermModalVisible}
        footer={null}
        wrapClassName='term-modal'
        centered={true}
        onCancel={() => setTermModalVisible(false)}
        closeIcon={
          <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g opacity="0.7">
              <line x1="13.9897" y1="24.9602" x2="25.3034" y2="13.6465" stroke="white"></line>
              <line x1="14.6968" y1="13.9896" x2="26.0105" y2="25.3033" stroke="white"></line>
            </g>
          </svg>
        }
        transitionName="ant-slide-down"
      >
        <TermTitle>
          Terms & Conditions
        </TermTitle>
        <ContentWrap>
          <p style={{ color: 'rgba(178, 178, 178)', margin: 0 }}>
            The RenArt NFT User Terms ("Terms") provide you with the
            opportunity to purchase Non-Fungible Token ("RenArt NFT") on
            the RenArt NFT trading platform ("Platform").
          </p>
          <ol style={{ color: 'rgba(178, 178, 178)', marginTop: '20px', padding: 0 }}>
            <ConetentList>
              RenArt NFT is an encrypted digital asset. When you
              purchase a RenArt NFT on the Blockchain through the
              Platform, you acquire the right to use the crypto-digital
              asset represented by the RenArt NFT and obtain the
              intellectual property within the description of the
              product statement.
            </ConetentList>
            <ConetentList>
              By agreeing to and completing the digital wallet link, you
              agree to these Terms and Conditions and shall abide by
              them in addition to all other provisions of these Terms
              and Conditions. By purchasing RenArt NFT assets displayed
              on the Platform through various third party digital wallet
              accounts ("Accounts"), you acknowledge that you have read,
              understand and agree to these Terms of Use, modified or
              changed. If you cannot comply with or do not agree to the
              contents of these Terms or if your country or region
              excludes some or all of the contents of these Terms,
              please stop using the service immediately.
            </ConetentList>
            <ConetentList>
              If you are under the age or are incapacitated, your legal
              guardian must read, understand and agree to these Terms
              and Conditions and perform subsequent modifications before
              you may continue to use the Service, otherwise, please
              stop using the service immediately.
            </ConetentList>
            <ConetentList>
              The Platform has the right to modify or change the
              contents of these Terms and Conditions at any time. In
              order to ensure your rights and interests, please pay
              attention to the terms and conditions announced on this
              platform.
            </ConetentList>
            <ConetentList>
              When you use the Platform, you may be required to comply
              with the terms of service or related regulations announced
              by the Platform according to the nature of each specific
              service, and the terms of service or related regulations
              announced by the Platform are part of these Terms of Use.
              You understand and agree that if you violate any of these
              terms and conditions, the Platform has the right to
              suspend or terminate all or part of your operation on the
              Platform without notice.
            </ConetentList>
            <ConetentList>
              When you make a purchase on the Platform, you must
              understand the following definitions.
              <p>
                (a) “Non-fungible tokens” or NFTs are cryptographic
                assets that meet the ERC-721/ERC-1155 standard or other
                similar non-fungible token standard on the blockchain
                with unique identification codes and metadata that
                distinguish them from each other . Unlike
                cryptocurrencies, they cannot be traded or exchanged at
                equivalency. This differs from fungible tokens like
                cryptocurrencies, which are identical to each other and,
                therefore, can be used as a medium for commercial
                transactions.
              </p>
              <p>
                (b) "Digital Asset" means a non-fungible token recorded
                on a blockchain ("Blockchain") using a smart contract.
              </p>
            </ConetentList>
            <ConetentList>
              Digital Asset transactions are recorded on the Blockchain
              in the form of Smart Contracts, i.e. all Digital Assets
              will not be controlled by RenArt or any party and will be
              subject to risks and uncertainties. The Platform does not
              own or control blockchain networks, browsers or any third
              party websites, products or services that you access,
              visit or use in order to use the Platform. The Platform
              does not own or control the digital wallets that you
              provide in connection with the Platform ("Third Party
              Wallets", including but not limited to MetaMask), and the
              Platform is not responsible for the acts or omissions of
              any such third parties, nor for any damages you may suffer
              as a result of your transactions or interactions with any
              such third parties. You understand and agree that when you
              use your digital wallet to transact through the Platform,
              your wallet address will be made public on the blockchain.
            </ConetentList>
            <ConetentList>
              Users are responsible for maintaining their own third
              party digital wallet private key and are fully responsible
              for any activity and behavior within the account.
            </ConetentList>
            <ConetentList>
              You fully understand and accept the risks associated with
              Encryption File System such as smart contracts,
              blockchain, non-fungible tokens and IPFS.
            </ConetentList>
            <ConetentList>
              Blockchain technology and digital assets are subject to
              many legal and regulatory uncertainties, and the Platform,
              Non-fungible tokens and digital assets may be adversely
              affected by one or more regulatory or legal
              investigations, lawsuits, inquiries, damages, fines or
              judgments that may prevent or limit the ability of users
              to continue to use such assets and technology. If your
              access to or use of the Platform is affected in any way,
              the Platform shall not be liable for your loss or damage.
            </ConetentList>
            <ConetentList>
              Cryptography at this moment is still an evolving field.
              Hacking or any advancement in technology (such as the
              development of quantum computers) may pose risks to
              blockchains, websites, non-fungible tokens and digital
              assets, including theft, loss or inaccessibility. You
              understand and agree to assume your own risk. You agree to
              accept the risk of website failure due to accidents or
              technical failures (including failures caused by unknown
              web attacks) and you agree not to hold the Platform liable
              for any related losses. The Platform is also not
              responsible for any damage, interruption, phishing,
              spoofing or other attacks caused by viruses that may
              affect your computer or other equipment.
            </ConetentList>
          </ol>
        </ContentWrap>
      </Modal>

    </Footer >
  )
}

export default AppFooter